export const array = (obj: any, deconstructObject = false): any[] => {

  if (Array.isArray(obj)) {
    return obj;

  } else if (deconstructObject && obj && typeof obj === 'object') {
    return Object.values(obj);
  }

  return [obj];
}

export const count = (obj: any, deconstructObject = false): number => {

  if (Array.isArray(obj)) {
    return obj.length;

  } else if (deconstructObject && obj && typeof obj === 'object') {
    return Object.keys(obj).length;
  }

  return 1;
}

export const countKeys = (obj: any): number => {

  if (obj && typeof obj === 'object') {
    return Object.keys(obj).length;
  }

  return 0;
}

export const range = (length: number): number[] => {
  return Array.from({length}, (_, i) => i);
}

export const some = (obj: any, deconstructObject = false): boolean => {

  if (Array.isArray(obj)) {
    return obj.length > 0;

  } else if (deconstructObject && obj && typeof obj === 'object') {
    return Object.keys(obj).length > 0;
  }

  return false;
}

export const someKeys = (obj: any): boolean => {

  if (obj && typeof obj === 'object') {
    return Object.keys(obj).length > 0;
  }

  return false;
}
